import { Component, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import {
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'obligations-amount',
    templateUrl: './obligations-amount.component.html',
    styleUrls: ['./obligations-amount.component.scss'],
    standalone: false
})
export class ObligationsAmountComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  error: ValidationErrors = null;
  sessionConsultant: boolean = false;
  pledge: PledgeRead;
  parameters: Parameters;
  minAmount: number = 0;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.parameters = this.pledge?.parameters;
    this.sessionConsultant =
      !!this.pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;

    const productId = this.pledge?.products?.[0]?.productId;

    if (productId) {
      this.productDao.getProduct('' + productId).subscribe(product => {
        this.minAmount = product?.financialMinimumInvestissement || 0;
        this.subscriptionFacade.initForm(this, {
          sessionConsultant: this.sessionConsultant,
          minAmount: this.minAmount,
        });
      });
    } else {
      this.subscriptionFacade.initForm(this, {
        sessionConsultant: this.sessionConsultant,
        minAmount: this.minAmount,
      });
    }
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
